import ProxyToolCreate from './ProxyToolCreate'
import ProxyToolEdit from './ProxyToolEdit'

export default {
  create: ProxyToolCreate,
  edit: ProxyToolEdit,
}
